import {css} from 'styled-components';

/**
 * The helper return styles which visually hide element
 */
export default css `
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  margin: -1px;
`;
